import BnBLogo from "../images/air.png"

export default function NavBar() {
    return (
        <nav>
            <img src={BnBLogo} alt="airbnb-logo"></img>
        </nav>
    )
}